import { Component, OnInit } from '@angular/core';
import { PhotoEditorService } from '../photo-editor/photo-editor.service';
import { PhotoEditorToolsZoomService } from '../photo-editor-tools/photo-editor-tools-zoom/photo-editor-tools-zoom.service';
import { PhotoEditorToolsTextSizeService } from '../photo-editor-tools/photo-editor-tools-text-size/photo-editor-tools-text-size.service';
import { tap } from 'rxjs/internal/operators/tap';
import { PhotoEditorCanvasService } from '../photo-editor-canvas/photo-editor-canvas.service';
import { PhotoEditorToolsMoveService } from '../photo-editor-tools/photo-editor-tools-move/photo-editor-tools-move.service';
import { PhotoEditorToolsFontSelectService } from '../photo-editor-tools/photo-editor-tools-font-select/photo-editor-tools-font-select.service';

@Component({
  selector: 'app-photo-editor-bar',
  templateUrl: './photo-editor-bar.component.html',
  styleUrls: ['./photo-editor-bar.component.scss']
})
export class PhotoEditorBarComponent implements OnInit {

  showFontOptions: boolean;
  showMoveOptions: boolean;
  showDeleteElement: boolean;

  constructor(private photoEditorService: PhotoEditorService,
              private photoEditorCanvasService: PhotoEditorCanvasService,
              private photoEditorToolsMoveService: PhotoEditorToolsMoveService,
              private photoEditorToolsTextSizeService: PhotoEditorToolsTextSizeService,
              private photoEditorToolsFontSelectService: PhotoEditorToolsFontSelectService,
              private photoEditorToolsZoomService: PhotoEditorToolsZoomService) { }

  ngOnInit() {
    this._listenShowFontOptionsListener();
    this._listenHideFontOptionsListener();
    this._listenShowMoveOptionsListener();
    this._listenHideMoveOptionsListener();
    this._listenShowDeleteElementListener();
  }

  public zoomPlus() {
    this.photoEditorToolsZoomService.zoomPlus();
  }

  public zoomMinus() {
    this.photoEditorToolsZoomService.zoomMinus();
  }

  public fontSizePlus() {
    this.photoEditorToolsTextSizeService.fontSizePlus();
  }

  public fontSizeMinus() {
    this.photoEditorToolsTextSizeService.fontSizeMinus();
  }

  public deleteElement() {
    this.photoEditorCanvasService.deleteElement();
  }

  public moveLeftElement() {
    this.photoEditorCanvasService.moveLeftElement();
  }

  public moveRightElement() {
    this.photoEditorCanvasService.moveRightElement();
  }

  public moveUpElement() {
    this.photoEditorCanvasService.moveUpElement();
  }

  public moveDownElement() {
    this.photoEditorCanvasService.moveDownElement();
  }

  public save() {
    this.photoEditorService.save();
  }

  private _listenShowFontOptionsListener() {
    this.photoEditorToolsTextSizeService.listenShowFontOptions().pipe(
      tap(res => !this.showFontOptions ? this.showFontOptions = true : null)
    ).subscribe();
  }
  private _listenHideFontOptionsListener() {
    this.photoEditorToolsTextSizeService.listenHideFontOptions().pipe(
      tap(res => this.showFontOptions ? this.showFontOptions = false : null)
    ).subscribe();
  }
  private _listenShowMoveOptionsListener() {
    this.photoEditorToolsMoveService.listenShowMoveOptions().pipe(
      tap(res => !this.showMoveOptions ? this.showMoveOptions = true : null)
    ).subscribe();
  }
  private _listenHideMoveOptionsListener() {
    this.photoEditorToolsMoveService.listenHideMoveOptions().pipe(
      tap(res => this.showMoveOptions ? this.showMoveOptions = false : null)
    ).subscribe();
  }
  private _listenShowDeleteElementListener() {
    this.photoEditorCanvasService.listenSelectedElement().pipe(
      tap(res => res ? this.showDeleteElement = true : this.showDeleteElement = false)
    ).subscribe();
  }
}
